import { ICommonPagination } from "types/CommonPagination";
import { IIdAndName } from "types/idAndName";

export interface IHandBook {
  id: number;
  name: string;
  type: ManualExpenditureType;
  measure: string;
  price: string;
  segment?: { subsegments: IIdAndName[]; parent: { name: string } };
  count: string;
  brand: string;
  code: string;
  product_type: string;
  producer: string;
  expenditure_products: {
    id: number;
    name: string;
    type: ManualExpenditureType;
    measure: string;
    price: string;
    segment?: { name: string; parent: { name: string } };
    count: string;
    brand: string;
    code: string;
    product_type: string;
    producer: string;
  }[];
}

export interface IHandBookAggregate {
  in_review_count: number;
}

export enum HANDBOOK_EXPENDITURE_APPROVAL_STATUS {
  DRAFT = "draft",
  IN_REVIEW = "in_review",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface IHandBookRequest extends ICommonPagination {
  type?: string | string[];
  name?: string;
  status: HANDBOOK_EXPENDITURE_APPROVAL_STATUS;
  ordering?: string;
}

export interface IHandBookAggregate {
  in_review_count: number;
}

export interface IHandBookExpenditureApproval {
  ids: number[];
  status: HANDBOOK_EXPENDITURE_APPROVAL_STATUS;
}

export interface IHandBookTemplate {
  id: number;
  name: string;
  author: {
    id: number;
    full_name: string;
  };
  status: string;
  approval_steps: IHandbookTemplateApprovalStep[];
  created_at: string;
}

export interface IHandbookTemplateApprovalStep {
  id: number;
  approver: {
    id: number;
    full_name: string;
  };
  status: "pending" | "approved" | "rejected";
  comment: string;
}

export interface IHandbookTemplatesListFilter {
  limit?: number;
  offset?: number;
  name?: string;
  ordering?: string;
}

export type IGetTemplateSectionsListFilter = {
  template_id?: number;
};

export interface ICreateTemplateSection {
  name: string;
  /** ID шаблона секции */
  template: number;
  /** ID родительской секции, если создаём подсекцию */
  parent?: number;
}

export interface IHandBookTemplateSection extends IIdAndName {
  children: Array<IIdAndName>;
  template: number;
  parent: number;
}

export interface IHandBookTemplateExpenditure {
  id: number;
  section_id: number;
  materials: Array<IMaterialInHandbookExpenditure>;
  manual_expenditure: IManualExpenditure;
  related_work_id: number;
  count: string;
  price: string;
  segment: number | null;
}

export interface IMaterialInHandbookExpenditure {
  id: number;
  manual_expenditure: Omit<IManualExpenditure, "count">;
}

export type ManualExpenditureType = "work" | "material" | "worker" | "machine" | "equipment" | "transport";

export interface IManualExpenditure extends IIdAndName {
  type: ManualExpenditureType;
  measure: string;
  price: string;
  count: string;
  brand: string;
  code: string;
  product_type: string;
  producer: string;
  related_work: number;
}

export interface ICreateTemplateExpenditure {
  section_id: number;
  manual_expenditure?: Partial<IManualExpenditure>;
  manual_expenditure_id: number;
  related_work_id?: number;
  count?: string;
  price?: string;
}

export interface IHandBookSegment extends IIdAndName {
  children: IIdAndName[];
  parent: number;
}
